import React from 'react';
import Header from '.././headers/header';
import {ERROR_404_MESSAGE_TITLE, ERROR_404_MESSAGE_HELPER} from '../../../constants/constants';
import {Link} from "react-router-dom";

class My404Component extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="layout-container">
                    <Header/>
                    <main className="container">
                        <div className="login-form error-404 box-shadow text-center">
                            <div class="error-404-message-title">{ERROR_404_MESSAGE_TITLE}</div>
                            <h3>{ERROR_404_MESSAGE_HELPER}</h3>
                            <h5>
                                <Link className="go-home-404" to="/home">HOME</Link>
                            </h5>
                        </div>

                    </main>
                </div>
            </React.Fragment>
        )
    }
}
export default My404Component;